import { connect } from 'react-redux'

import VendorPricingAgreementsReports from '@components/vendor-pricing-agreements/VendorPricingAgreementsReports'

import services from '@services'
import coordinators from '@coordinators'
import presenters from '@presenters'
import { HandleError } from '@coordinators/composed'

const mapDispatchToProps = () => {
  const { RestService, MarketService, UIService } = services
  const { LoadMarkets, GenerateVendorPricingAgreementsReport } = coordinators
  const { pResponseHeadquarters } = presenters.Api

  const getHeadquarters = LoadMarkets({
    MarketService,
    RestService,
    pResponseHeadquarters,
  })

  const generateVendorPricingAgreementsReport =
    GenerateVendorPricingAgreementsReport({
      RestService,
      HandleError,
    })

  const {
    FlashMessage: { displaySuccessMessage },
  } = UIService

  return {
    getHeadquarters,
    generateVendorPricingAgreementsReport,
    displaySuccessMessage,
  }
}

export default connect(
  undefined,
  mapDispatchToProps,
)(VendorPricingAgreementsReports)
